import './App.css';
import Home from './components/Home';
import { Routes, Route, useLocation } from 'react-router-dom';
import Category from './components/Category';
import { CartProvider } from './components/CartContext';
import Header from './components/Header';
import Items from './components/Items';
import Footer from './components/Footer';
import CartPopup from './components/CartPopup';
import { useState } from 'react';
import Contact from './components/Contact';
import About from './components/About';
import Privacy from './components/Privacy';
import NotFound from './components/NotFound';
import ProductDetail from './components/ProductDetail';
import Checkout from './components/Checkout';
import useAgentId from './components/useAgentId';
import UploadImage from './components/UploadImage';
import SearchResults from './components/SearchResults';
import PreCheckout from './components/PreCheckout';
import LoginPage from "./components/LoginPage";
import Register from './components/Register';
import RecruitForm from './components/RecruitForm';
import OfflineOrder from './components/custOrder';
import OrderStatus from './components/OrderStatus';
import AgentPage from './components/AgentPage';
import AgentDashboard from './components/AgentDashboard';
import AppCatalogue from './components/AppCatalogue';
import Profile from './components/Profile';
import Ordering from './components/Dashboards/Ordering';
import AdminLogin from './components/AdminLogin';
import MakerDashboard from './components/Dashboards/MakerDashboard';
import DeliveryDashboard from './components/Dashboards/DeliveryDashboard';
import ProtectedRoute from './ProtectedRoute';
import ScrollToTop from "./components/ScrollToTop";
import RouteLoader from "./components/Loader";


function App() {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { getUrlWithAgentId } = useAgentId();
  const location = useLocation();

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  const hideLayoutRoutes = ['/admin/dashboard', '/admin-login', '/maker/dashboard', '/delivery/dashboard', '/login', '/register', '/recruit','/order_status','/agent-page','/agent-dashboard','/catalogue','/offline-order'];

  const shouldHideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <CartProvider>
      <RouteLoader />
      <div className="App">
        {!shouldHideLayout && <Header toggleCart={toggleCart} />}
        {!shouldHideLayout && <CartPopup isOpen={isCartOpen} toggleCart={toggleCart} />}
        <main className={shouldHideLayout ? "" : "page-content"}>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path="/collections/:categorySlug" element={<Category />} />
          <Route path='/items' element={<Items />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/about' element={<About />} />
          <Route path='/privacy' element={<Privacy />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/upload" element={<UploadImage />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/precheckout" element={<PreCheckout />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/register" element={<Register />} />
          <Route path="/recruit" element={<RecruitForm />} />
          <Route path="/offline-order" element={<OfflineOrder />} />
          <Route path="/order_status" element={<OrderStatus />} />
          <Route path="/agent-page" element={<AgentPage />} />
          <Route path="/agent-dashboard" element={<AgentDashboard />} />
          <Route path="/catalogue" element={<AppCatalogue />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Ordering />
              </ProtectedRoute>
            }
          />
          <Route
            path="/maker/dashboard"
            element={
              <ProtectedRoute allowedRoles={['maker']}>
                <MakerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/delivery/dashboard"
            element={
              <ProtectedRoute allowedRoles={['delivery']}>
                <DeliveryDashboard />
              </ProtectedRoute>
            }
          />
          {/* any other address */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </main>

        {!shouldHideLayout && <Footer />}
      </div>
      <ScrollToTop /> 
    </CartProvider>
  );
}

export default App;
